import env from "@/config/env";

const api = {
  post: (url: string, data: unknown, options: RequestInit = {}) => {
    return fetch(`${env.API_BASE_URL}${url}`, {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
      },
      ...options,
    });
  },
};

export default api;
